import config from "config";

import { checkTenantAllowed, getTenantFromHostname } from "./tenant-utils";

/**
 * Validates tenant access based on current URL and JWT claims
 * @param jwtTenants - Array of tenant claims from the JWT token
 * @returns boolean indicating if access is allowed for current tenant
 */
export const validateCurrentTenantAccess = (
  jwtTenants: string[] | undefined
): boolean => {
  const { instance } = config.get();
  const currentTenant = getTenantFromHostname();

  // Always allow access on localhost
  if (currentTenant === "localhost" && instance === "local") {
    return true;
  }

  return checkTenantAllowed(currentTenant, jwtTenants);
};
